import React from 'react'
import { Modal, Button, Form, Row, Col } from 'react-bootstrap'

const UpdateAddressModal = ({ show, onHide, onConfirm, tempAddress, onAddressChange }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Billing Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type='text'
                  name='companyName'
                  value={tempAddress.companyName}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type='text'
                  name='fullName'
                  value={tempAddress.fullName}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group className='mb-3'>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type='text'
                  name='address'
                  value={tempAddress.address}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>City</Form.Label>
                <Form.Control
                  type='text'
                  name='city'
                  value={tempAddress.city}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>State</Form.Label>
                <Form.Control
                  type='text'
                  name='state'
                  value={tempAddress.state}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type='text'
                  name='country'
                  value={tempAddress.country}
                  onChange={onAddressChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-primary' onClick={onHide}>
          Close
        </Button>
        <Button variant='primary' onClick={onConfirm}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UpdateAddressModal
